module.exports = __webpack_public_path__ + "img/50_19.d26dfcb3.png";